import script from "./Step1Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1Form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__